import React from 'react';
import { Heading } from 'theme-ui';
import Box from 'elements/Box';

const NotFound = () => (
  <Box width="100%" style={{ textAlign: 'center' }}>
    <Box style={{ display: 'inline-block', margin: '0 auto' }}>
      <Heading>404 Not Found</Heading>
    </Box>
  </Box>
);

export default NotFound;
